import type { AppInfo } from "@/lib/api";
import { GCAL_LOGO, GMAIL_LOGO, MS_LOGO } from "./logos";

// The hub apps a chief of staff runs on. The inbox step resolves each slug
// against the live catalog and falls back to these entries (logos inlined)
// when the hub does not know one.
export type CosAppKind = "inbox" | "calendar";
export type CosApp = AppInfo & { kind: CosAppKind };

export const COS_APPS: CosApp[] = [
  { slug: "gmail", name: "Gmail", authType: "oauth", description: "Email by Google", logoUrl: GMAIL_LOGO, categories: ["email"], kind: "inbox" },
  { slug: "google_calendar", name: "Google Calendar", authType: "oauth", description: "Scheduling by Google", logoUrl: GCAL_LOGO, categories: ["calendar"], kind: "calendar" },
  { slug: "microsoft_outlook", name: "Microsoft Outlook", authType: "oauth", description: "Email by Microsoft", logoUrl: MS_LOGO, categories: ["email"], kind: "inbox" },
  { slug: "microsoft_outlook_calendar", name: "Microsoft Outlook Calendar", authType: "oauth", description: "Scheduling by Microsoft", logoUrl: MS_LOGO, categories: ["calendar"], kind: "calendar" },
];

// Which of the two needs (inbox, calendar) the connected slugs cover.
export function connectedKinds(connected: string[]): Set<CosAppKind> {
  const kinds = new Set<CosAppKind>();
  for (const app of COS_APPS) if (connected.includes(app.slug)) kinds.add(app.kind);
  return kinds;
}
